const LANGUAGE_ORDER = [
  'english',
  'french',
  'german',
  'spanish',
  'chinese',
  'hindi',
  'telugu',
  'kannada',
  'gujarati',
  'marathi',
  'tamil',
  'bengali',
  'punjabi',
  'malayalam',
  'odia',
];

export function normalizeLanguage(value) {
  const lang = String(value || 'english').trim().toLowerCase();
  return lang || 'english';
}

export function languageLabel(slug) {
  const s = normalizeLanguage(slug);
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function getLanguageCounts(books) {
  return (books || []).reduce((acc, book) => {
    const lang = normalizeLanguage(book.language);
    acc[lang] = (acc[lang] || 0) + 1;
    return acc;
  }, {});
}

export function sortedLanguageIds(languageCounts) {
  const ids = Object.keys(languageCounts || {});
  const ordered = LANGUAGE_ORDER.filter((id) => ids.includes(id));
  const rest = ids.filter((id) => !LANGUAGE_ORDER.includes(id)).sort();
  return [...ordered, ...rest];
}

export function filterBooksByLanguage(books, languageFilter) {
  if (!languageFilter || languageFilter === 'all') return books || [];
  const target = normalizeLanguage(languageFilter);
  return (books || []).filter((b) => normalizeLanguage(b.language) === target);
}
